import { GRAMMAR, PLAGIARISM } from '@src/components/Cards/constants'
import { CheckCategory, EXPERT_CHECK } from '@src/state/document/types'
import {
  CONFIRM_LEAVE_MODAL,
  ONE_AUTH_MODAL,
  PAPER_SCORECARD_MODAL,
  PAYMENT_MODAL,
  PLAGIARISM_SOURCES_MODAL,
  UPLOAD_WIDGET_MODAL,
} from '@src/state/modals/actions'
import { RootState } from '@src/state/types'
import { createSelector } from 'reselect'

const getModals = (state: RootState) => state.modals

export const getPlagiarismMetadataId = createSelector([getModals], modals => {
  const plagiarismModal = modals[PLAGIARISM_SOURCES_MODAL]
  return plagiarismModal ? plagiarismModal.metadataId : undefined
})

export const getConfirmLeaveNavigate = createSelector([getModals], modals => {
  const modal = modals[CONFIRM_LEAVE_MODAL]
  return modal ? modal.navigateToNextLocation : undefined
})

export const getUploadWidgetModalProps = createSelector(
  [getModals],
  modals => modals[UPLOAD_WIDGET_MODAL]
)

export const getOneAuthModalProps = createSelector(
  [getModals],
  modals => modals[ONE_AUTH_MODAL]
)

export const getNavigateToCategory = (category: CheckCategory) =>
  createSelector([getModals], modals => {
    const modal = modals[PAPER_SCORECARD_MODAL]

    switch (category) {
      case EXPERT_CHECK:
        return modal?.navigateToExpertCheck
      case PLAGIARISM:
        return modal?.navigateToPlagiarism
      case GRAMMAR:
        return modal?.navigateToGrammar
    }
  })

export const getModalIsVisible = createSelector(
  [getModals],
  modals => !!Object.keys(modals).length
)

export const getIsPaymentModalVisible = createSelector(
  [getModals],
  modals => !!modals[PAYMENT_MODAL]
)



// WEBPACK FOOTER //
// ./src/state/modals/selectors.ts